import React, { useState, useEffect } from "react";
import {
  Container,
  Nav,
  Navbar,
  Modal,
  Col,
  Row,
  Table,
  Offcanvas,
} from "react-bootstrap";
import { Buttons, ClickButton } from "../components/Buttons";
import { TableUI } from "../components/Tables";
import { PageHead, PageTitle } from "../components/PageTitle";
import {
  Calender,
  DropDownUI,
  TextInputForm,
  LoadingSpinner,
} from "../components/Forms";
import PropagateLoader from "react-spinners/PropagateLoader";
import { useLocation, Navigate } from "react-router-dom";
import API_DOMAIN from "../config/config";
import { MdOutlineClose } from "react-icons/md";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment/moment";
import { ButtonBase } from "@mui/material";
import companyId from "../config/companyId";

const ProductHistory = [
  "S No",
  "Date",
  "Receipt No",
  "Name",
  "Total",
  "Status",
];

const PayOut = () => {
  const [openFilter, setFilter] = useState(false);
  const closeFilter = () => setFilter(false);
  const showFilter = () => setFilter(true);
  const [show, setShow] = useState(false);
  const [tempSearchText, setTempSearchText] = useState("");
  const [crtPayOut, setCrtPayOut] = useState(null);
  const [formData, setFormData] = useState({
    party_id: "",
    voucher_date: new Date(),
    paid: "",
  });
  console.log("Form Data:", formData);
  const location = useLocation();
  const { type, rowData } = location.state || {};
  const [filterData, setFilterData] = useState({
    search_text: "",
    party_id: "",
    from_date: null, // Changed to null to avoid ambiguity
    to_date: null, // Changed to null to avoid ambiguity
  });
  console.log("filter Data", filterData);
  const [loading, setLoading] = useState(false);
  const [purchasepartyData, setPurchasepartyData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [filterKey, setFilterKey] = useState(Date.now()); // Unique key for filter reset
  const [isLoggedIn, setIsLoggedIn] = useState(true);

  const handleClose = () => {
    setShow(false);
    setCrtPayOut(null);
    setFormData({
      party_id: "",
      voucher_date: new Date(),
      paid: "",
    });
  };

  const handleShow = () => {
    setCrtPayOut(null);
    setFormData({
      party_id: "",
      voucher_date: new Date(),
      paid: "",
    });
    setShow(true);
  };

  const handleEditClick = (rowdata) => {
    const isValidDate = moment(
      rowdata.voucher_date,
      ["YYYY-MM-DD", "DD-MM-YYYY"],
      true
    ).isValid();
    const parsedDate = isValidDate
      ? moment(
        rowdata.voucher_date,
        ["YYYY-MM-DD", "DD-MM-YYYY"],
        true
      ).toDate()
      : new Date(); // fallback to today if invalid

    setCrtPayOut({
      ...rowdata,
      voucher_date: parsedDate,
    });

    setShow(true);
  };

  const handleChanges = (e, fieldName) => {
    const value = e.target ? e.target.value : e.value;
    setFilterData({
      ...filterData,
      [fieldName]: value,
    });
  };

  const handleChange = (e, fieldName) => {
    const value = e.target ? e.target.value : e.value;
    if (crtPayOut !== null) {
      setCrtPayOut({
        ...crtPayOut,
        [fieldName]: value,
      });
    } else {
      setFormData({
        ...formData,
        [fieldName]: value,
      });
    }
  };

  const setFormattedDate = (
    value,
    field,
    format = "YYYY-MM-DD",
    isFilter = false
  ) => {
    const formattedDate = value ? moment(value).format(format) : null;

    if (!formattedDate || !moment(formattedDate, format, true).isValid()) {
      console.warn(`Skipping invalid date for field ${field}:`, value);
      return;
    }

    const newDateState = { [field]: formattedDate };

    if (isFilter) {
      setFilterData((prev) => ({ ...prev, ...newDateState }));
    } else if (crtPayOut !== null) {
      setCrtPayOut((prev) => ({ ...prev, ...newDateState }));
    } else {
      setFormData((prev) => ({ ...prev, ...newDateState }));
    }
  };

  const errorAlert = (input) => {
    toast.error(input, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const successAlert = (success) => {
    toast.success(success, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const clearFilter = () => {
    setFilterData({
      search_text: "",
      party_id: "",
      from_date: null, // Explicitly set to null
      to_date: null, // Explicitly set to null
    });
    setTempSearchText("");
    setFilterKey(Date.now()); // Force re-render
  };

  const fetchAllPayoutData = async () => {
    setLoading(true);
    try {
      
      if (!companyId) throw new Error("Company ID not found");

      const payoutPayload = {
        search_text: filterData.search_text || "",
        party_id: filterData.party_id || "",
        from_date: filterData.from_date || "",
        to_date: filterData.to_date || "",
        company_id: companyId,
      };
      console.log("filterData", filterData);
      console.log("Payout request payload:", JSON.stringify(payoutPayload));

      const [partyRes, payoutRes] = await Promise.all([
        fetch(`${API_DOMAIN}/purchase_party.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ search_text: "", company_id: companyId }),
        }),
        fetch(`${API_DOMAIN}/payout.php?id=${companyId}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payoutPayload),
        }),
      ]);

      let partyJson = null;

      if (!partyRes.ok) {
        const text = await partyRes.text();
        console.error("Non-OK party response:", partyRes.status, text);
        toast.error(`Party API error: ${partyRes.status}`, {
          position: "top-center",
          autoClose: 3000,
          theme: "colored",
        });
        setPurchasepartyData([]);
      } else {
        const contentType = partyRes.headers.get("Content-Type");
        if (!contentType || !contentType.includes("application/json")) {
          const text = await partyRes.text();
          console.error("Invalid party content type:", contentType, text);
          toast.error("Invalid response format from party API", {
            position: "top-center",
            autoClose: 3000,
            theme: "colored",
          });
          setPurchasepartyData([]);
        } else {
          partyJson = await partyRes.json();
          console.log("Party API response:", partyJson);
          if (partyJson.status !== 200) {
            toast.error(partyJson.msg || "Failed to fetch party data");
            setPurchasepartyData([]);
          } else {
            setPurchasepartyData(partyJson.data || []);
          }
        }
      }

      if (!payoutRes.ok) {
        const text = await payoutRes.text();
        console.error("Non-OK payout response:", payoutRes.status, text);
        toast.error(`Payout API error: ${payoutRes.status}`, {
          position: "top-center",
          autoClose: 3000,
          theme: "colored",
        });
        setUserData([]);
        return;
      }

      const contentType = payoutRes.headers.get("Content-Type");
      if (!contentType || !contentType.includes("application/json")) {
        const text = await payoutRes.text();
        console.error("Invalid payout content type:", contentType, text);
        toast.error("Invalid response format from payout API", {
          position: "top-center",
          autoClose: 3000,
          theme: "colored",
        });
        setUserData([]);
        return;
      }

      const payoutText = await payoutRes.text();
      console.log("Raw payout response:", payoutText);
      let payoutJson;
      try {
        payoutJson = JSON.parse(payoutText);
      } catch (err) {
        console.error("❌ JSON parse error in payout.php:", err.message);
        toast.error("Invalid response from payout API", {
          position: "top-center",
          autoClose: 3000,
          theme: "colored",
        });
        setUserData([]);
        return;
      }

      console.log("Payout API response:", payoutJson);

      if (payoutJson.status !== 200) {
        toast.error(payoutJson.msg || "Failed to fetch payout data");
        setUserData([]);
        return;
      }

      const enrichedData = (payoutJson.data || []).map((item) => {
        const party = (
          partyJson && partyJson.status === 200
            ? partyJson.data
            : purchasepartyData
        ).find((p) => p.party_id === item.party_id);
        return {
          ...item,
          party_name: party?.party_name || "Unknown",
          voucher_date: moment(item.voucher_date, "YYYY-MM-DD", true).isValid()
            ? item.voucher_date
            : "",
        };
      });

      setUserData(enrichedData);
    } catch (error) {
      console.error("fetchAllPayoutData error:", error.message);
      toast.error("Error fetching payout data", {
        position: "top-center",
        autoClose: 3000,
        theme: "colored",
      });
      setUserData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    try {
      
      if (!companyId) {
        errorAlert("Company ID missing!");
        return;
      }

      if (!formData.party_id || !formData.voucher_date || !formData.paid) {
        errorAlert("All fields are required!");
        return;
      }

      if (!moment(formData.voucher_date, "DD-MM-YYYY", true).isValid()) {
        errorAlert("Invalid voucher date format! Please use DD-MM-YYYY.");
        return;
      }

      const formattedData = {
        ...formData,
        voucher_date: moment(formData.voucher_date, "DD-MM-YYYY").format(
          "DD-MM-YYYY"
        ),
        company_id: companyId,
      };
      console.log("Submit request payload:", JSON.stringify(formattedData));

      const response = await fetch(`${API_DOMAIN}/payout.php?id=${companyId}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formattedData),
      });

      console.log("Response status:", response.status);
      console.log("Response headers:", [...response.headers.entries()]);

      if (!response.ok) {
        const text = await response.text();
        console.error("Non-OK response:", response.status, text);
        toast.error(`Payout API error: ${response.status}`, {
          position: "top-center",
          autoClose: 3000,
          theme: "colored",
        });
        return;
      }

      const contentType = response.headers.get("Content-Type");
      if (!contentType || !contentType.includes("application/json")) {
        const text = await response.text();
        console.error("Invalid content type:", contentType, text);
        toast.error("Invalid response format from payout API", {
          position: "top-center",
          autoClose: 3000,
          theme: "colored",
        });
        return;
      }

      const responseText = await response.text();
      console.log("Raw response:", responseText);
      let responseData;
      try {
        responseData = JSON.parse(responseText);
      } catch (err) {
        console.error("❌ JSON parse error in payout.php:", err.message);
        toast.error("Invalid response from payout API", {
          position: "top-center",
          autoClose: 3000,
          theme: "colored",
        });
        return;
      }

      console.log("Submit response:", responseData);

      if (responseData.status === 200) {
        setFormData({
          party_id: "",
          voucher_date: "",
          paid: "",
        });

        successAlert(responseData.msg || "Payout created successfully");
        setTimeout(() => {
          handleClose();
          fetchAllPayoutData();
        }, 1000);
      } else {
        errorAlert(responseData.msg || "Failed to create payout");
      }
    } catch (error) {
      console.error("Submission error:", error.message);
      toast.error("Error while submitting payout", {
        position: "top-center",
        autoClose: 3000,
        theme: "colored",
      });
    }
  };

  const handleUpdateSubmit = async () => {
    try {
      
      if (!companyId) {
        errorAlert("Company ID missing!");
        return;
      }

      if (!crtPayOut.party_id || !crtPayOut.voucher_date || !crtPayOut.paid) {
        errorAlert("All fields are required!");
        return;
      }

      if (!moment(crtPayOut.voucher_date, "DD-MM-YYYY", true).isValid()) {
        errorAlert("Invalid voucher date format! Please use DD-MM-YYYY.");
        return;
      }

      const formattedData = {
        payout_id: crtPayOut.payout_id,
        paid: crtPayOut.paid,
        voucher_date: moment(crtPayOut.voucher_date, "DD-MM-YYYY").format(
          "DD-MM-YYYY"
        ),
        party_id: crtPayOut.party_id,
        company_id: companyId,
      };
      console.log("Update request payload:", JSON.stringify(formattedData));

      const response = await fetch(`${API_DOMAIN}/payout.php?id=${companyId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formattedData),
      });

      console.log("Response status:", response.status);
      console.log("Response headers:", [...response.headers.entries()]);

      if (!response.ok) {
        const text = await response.text();
        console.error("Non-OK response:", response.status, text);
        toast.error(`Payout API error: ${response.status}`, {
          position: "top-center",
          autoClose: 3000,
          theme: "colored",
        });
        return;
      }

      const contentType = response.headers.get("Content-Type");
      if (!contentType || !contentType.includes("application/json")) {
        const text = await response.text();
        console.error("Invalid content type:", contentType, text);
        toast.error("Invalid response format from payout API", {
          position: "top-center",
          autoClose: 3000,
          theme: "colored",
        });
        return;
      }

      const responseText = await response.text();
      console.log("Raw response:", responseText);
      let responseData;
      try {
        responseData = JSON.parse(responseText);
      } catch (err) {
        console.error("❌ JSON parse error in payout.php:", err.message);
        toast.error("Invalid response from payout API", {
          position: "top-center",
          autoClose: 3000,
          theme: "colored",
        });
        return;
      }

      console.log("Update response:", responseData);

      if (responseData.status === 200) {

        successAlert(responseData.msg || "Payout updated successfully");
        setTimeout(() => {
          handleClose();
          fetchAllPayoutData();
        }, 2000);
      } else {
        errorAlert(responseData.msg || "Failed to update payout");
      }
    } catch (error) {
      console.error("Update error:", error.message);
      toast.error("Error while updating payout", {
        position: "top-center",
        autoClose: 3000,
        theme: "colored",
      });
    }
  };

  const filteredUserData = userData.filter((item) => {
    const voucherNo = item.voucher_no?.toString().toLowerCase() || "";
    const receiptNo = item.receipt_no?.toString().toLowerCase() || "";
    const partyName = item.party_name?.toLowerCase() || "";
    const searchText = filterData.search_text?.toString().toLowerCase() || "";

    const isSearchMatch =
      searchText === "" ||
      voucherNo.includes(searchText) ||
      receiptNo.includes(searchText) ||
      partyName.includes(searchText);

    const isPartyMatch =
      !filterData.party_id || item.party_id === filterData.party_id;

    const itemDate = moment(item.voucher_date, "YYYY-MM-DD", true);
    const fromDate = filterData.from_date
      ? moment(filterData.from_date, "YYYY-MM-DD", true)
      : null;
    const toDate = filterData.to_date
      ? moment(filterData.to_date, "YYYY-MM-DD", true)
      : null;

    const isDateMatch =
      ((!fromDate || !fromDate.isValid()) && (!toDate || !toDate.isValid())) ||
      (fromDate &&
        fromDate.isValid() &&
        toDate &&
        toDate.isValid() &&
        itemDate.isValid() &&
        itemDate.isBetween(fromDate, toDate, "day", "[]")) ||
      (fromDate &&
        fromDate.isValid() &&
        !toDate &&
        itemDate.isValid() &&
        itemDate.isSameOrAfter(fromDate, "day")) ||
      (!fromDate &&
        toDate &&
        toDate.isValid() &&
        itemDate.isValid() &&
        itemDate.isSameOrBefore(toDate, "day"));

    return (
      isSearchMatch &&
      isPartyMatch &&
      (itemDate.isValid() ? isDateMatch : false)
    );
  });

  console.log("filteredUserData", filteredUserData);

  useEffect(() => {
    fetchAllPayoutData();
  }, []);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setFilterData((prev) => ({
        ...prev,
        search_text: tempSearchText,
      }));
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [tempSearchText]);

  useEffect(() => {
    const checkSession = async () => {
      try {
        const session = localStorage.getItem("session");
        if (!session) {
          setIsLoggedIn(false);
        }
      } catch (error) {
        console.error("Error checking session:", error.message);
        setIsLoggedIn(false);
      }
    };
    checkSession();
  }, []);

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (loading) {
    return <LoadingSpinner message="Loading PayoutPage..." height="300px" />;
  }

  return (
    <div style={{ cursor: "pointer" }}>
      <Container fluid className="pt-2">
        <div className="main p-3 my-2">
          <div className="mx-2">
            <Navbar>
              <Navbar.Brand>
                <PageTitle PageTitle="Pay Out" />
              </Navbar.Brand>
              <Nav className="ms-auto">
                <span className="mx-2 py-2">
                  <Buttons lable={<>Filter</>} onClick={showFilter} />
                </span>
                <span className="mx-2 py-2">
                  <Buttons lable={<>Clear</>} onClick={clearFilter} />
                </span>
              </Nav>
            </Navbar>
          </div>
          <Offcanvas show={openFilter} onHide={closeFilter} placement="end">
            <Offcanvas.Body>
              <Row>
                <Col lg="6">
                  <PageTitle PageTitle="Purchase Bill" />
                </Col>
                <Col lg="6" className="align-self-center">
                  <div className="text-end">
                    <Buttons onClick={closeFilter} lable={<MdOutlineClose />} />
                  </div>
                </Col>
              </Row>
              <div>
                <div className="py-3">
                  <TextInputForm
                    labelname="Search Receipt"
                    placeholder="Search Receipt"
                    name="search_text"
                    value={tempSearchText}
                    onChange={(e) => setTempSearchText(e.target.value)}
                  />
                </div>
                <div className="py-3">
                  <DropDownUI
                    key={filterKey} // Use filterKey for consistency
                    optionlist={purchasepartyData.map((user) => ({
                      value: user.party_id,
                      label: user.party_name,
                    }))}
                    placeholder="Select Party"
                    labelname="Select Party"
                    name="party_id"
                    value={filterData.party_id}
                    onChange={(updatedFormData) =>
                      setFilterData({
                        ...filterData,
                        party_id: updatedFormData.party_id,
                      })
                    }
                  />
                </div>
                <Row>
                  <Col lg="6" className="align-self-center">
                    <Calender
                      calenderlabel="From Date"
                      initialDate={
                        filterData.from_date &&
                          moment(filterData.from_date, "YYYY-MM-DD", true).isValid()
                          ? moment(filterData.from_date, "YYYY-MM-DD").toDate()
                          : null
                      }
                      setLabel={(date) =>
                        setFormattedDate(date, "from_date", "YYYY-MM-DD", true)
                      }
                      disabled={false}
                    />
                  </Col>
                  <Col lg="6" className="align-self-center">
                    <Calender
                      calenderlabel="To Date"
                      initialDate={
                        filterData.to_date &&
                          moment(filterData.to_date, "YYYY-MM-DD", true).isValid()
                          ? moment(filterData.to_date, "YYYY-MM-DD").toDate()
                          : null
                      }
                      setLabel={(date) =>
                        setFormattedDate(date, "to_date", "YYYY-MM-DD", true)
                      }
                      disabled={false}
                    />
                  </Col>
                  <Col lg="6" className="align-self-center">
                    <div className="my-5 text-center">
                      <Buttons
                        lable="Apply"
                        onClick={() => {
                          closeFilter();
                        }}
                      />
                    </div>
                  </Col>
                  <Col lg="6" className="align-self-center">
                    <div className="my-5 text-center">
                      <Buttons lable="Clear" onClick={clearFilter} />
                    </div>
                  </Col>
                </Row>
              </div>
            </Offcanvas.Body>
          </Offcanvas>
        </div>
        <div className="main p-3">
          <div className="py-1 mx-2">
            <Navbar>
              <Navbar.Brand>
                <PageTitle PageTitle="Transactions" />
              </Navbar.Brand>
              <Nav className="ms-auto">
                <span className="mx-2 py-2">
                  <Buttons lable={<>Add New</>} onClick={handleShow} />
                </span>
              </Nav>
            </Navbar>
          </div>
          <div className="py-2 c-table table-scroll">
            <TableUI
              headers={ProductHistory}
              body={filteredUserData.map((item) => ({
                ...item,
                voucher_date: moment(
                  item.voucher_date,
                  "YYYY-MM-DD",
                  true
                ).isValid()
                  ? item.voucher_date
                  : "",
              }))}
              type="purchasepayout"
              pageview="yes"
              handleEditClick={handleEditClick}
              onDelete={fetchAllPayoutData}
            />
          </div>
        </div>
      </Container>
      <Modal show={show} onHide={handleClose} size="lg" centered scrollable>
        <Modal.Header>
          <Modal.Title>
            <PageHead
              pagehead={`PayOut${crtPayOut !== null ? " Update" : " Creation"}`}
              onClick={handleClose}
            />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container fluid>
            <Table>
              <tr>
                <td className="w-50">
                  <DropDownUI
                    optionlist={purchasepartyData.map((user) => ({
                      value: user.party_id,
                      label: user.party_name,
                    }))}
                    required={"*"}
                    placeholder="Select Party"
                    labelname="Select Party"
                    name="party_id"
                    value={
                      crtPayOut !== null
                        ? crtPayOut.party_id
                        : formData.party_id
                    }
                    onChange={(updatedFormData) => {
                      if (crtPayOut !== null) {
                        setCrtPayOut({
                          ...crtPayOut,
                          party_id: updatedFormData.party_id,
                        });
                      } else {
                        setFormData({
                          ...formData,
                          party_id: updatedFormData.party_id,
                        });
                      }
                    }}
                  />
                </td>
                <td className="float-end">
                  <div className="py-3">
                    <Calender
                      calenderlabel="Date"
                      required={"*"}
                      initialDate={
                        (crtPayOut
                          ? crtPayOut.voucher_date
                          : formData.voucher_date) &&
                          moment(
                            crtPayOut
                              ? crtPayOut.voucher_date
                              : formData.voucher_date,
                            "DD-MM-YYYY",
                            true
                          ).isValid()
                          ? moment(
                            crtPayOut
                              ? crtPayOut.voucher_date
                              : formData.voucher_date,
                            "DD-MM-YYYY"
                          ).toDate()
                          : null
                      }
                      setLabel={(date) =>
                        setFormattedDate(
                          date,
                          "voucher_date",
                          "DD-MM-YYYY",
                          false
                        )
                      }
                      disabled={false}
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <div className="py-3 w-75 ms-auto">
                    <TextInputForm
                      labelname="Paid"
                      placeholder="Paid"
                      required={"*"}
                      name="paid"
                      value={
                        crtPayOut !== null ? crtPayOut.paid : formData.paid
                      }
                      onChange={(e) => handleChange(e, "paid")}
                    />
                  </div>
                </td>
              </tr>
            </Table>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Col lg="12" md="12" xs="12" className="py-5 align-self-center">
            <div className="text-center">
              {crtPayOut !== null ? (
                <>
                  <ToastContainer
                    position="top-center"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                  />
                  <span className="mx-2">
                    <ClickButton
                      label={<>Update</>}
                      onClick={handleUpdateSubmit}
                    />
                  </span>
                  <span className="mx-2">
                    <ClickButton label={<>Cancel</>} onClick={handleClose} />
                  </span>
                </>
              ) : (
                <>
                  <ToastContainer
                    position="top-center"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                  />
                  <span className="mx-2">
                    <ClickButton label={<>Submit</>} onClick={handleSubmit} />
                  </span>
                  <span className="mx-2">
                    <ClickButton label={<>Cancel</>} onClick={handleClose} />
                  </span>
                </>
              )}
            </div>
          </Col>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default PayOut;
